<div class="relative flex flex-col w-full h-full">

    <!-- Dismiss button -->
    <div class="absolute top-0 right-0 pt-4 pr-4">
        <button
            mat-icon-button
            [matDialogClose]="undefined">
            <mat-icon
                class="text-secondary"
                [svgIcon]="'mat_outline:close'"></mat-icon>
        </button>
    </div>

    <!-- Content -->
    <div class="flex flex-col sm:flex-row flex-auto items-center sm:items-start p-8 pb-6 sm:pb-8">

        <!-- Icon -->
        <div
            class="flex flex-0 items-center justify-center w-10 h-10 sm:mr-4 rounded-full text-primary-600 bg-primary-100 dark:text-primary-50 dark:bg-primary-600">
            <mat-icon
                class="text-current"
                [svgIcon]="'mat_outline:content_copy'"></mat-icon>
        </div>

        <div
            class="flex flex-col items-center sm:items-start mt-4 sm:mt-0 sm:pr-8 space-y-1 text-center sm:text-left">

            <!-- Title -->
            <div class="text-xl leading-6 font-medium">Regel duplizieren</div>

            <!-- Message -->
            <div class="text-secondary">
                Bitte bestätigen Sie, dass Sie diese Regel duplizieren möchten.
                <span class="font-semibold text-hint">Danach nicht vergessen, die Ziel-Zuordnung anzupassen,
                da mehrere Regeln mit identischer Zuordnung zu schlechten Ergebnissen führen können.</span>
            </div>
        </div>

    </div>

    <!-- Actions -->
    <div
        class="flex items-center justify-center sm:justify-end px-6 py-4 space-x-3 bg-gray-50 dark:bg-black dark:bg-opacity-10 static bottom-0">

        <!-- Cancel -->
        <button
            mat-stroked-button
            [matDialogClose]="'cancelled'">
            Abbrechen
        </button>

        <!-- Confirm -->
        <button
            mat-flat-button
            color="primary"
            (click)="duplicate()"
            [disabled]="this.duplicating">
            <span *ngIf="!this.duplicating">Duplizieren</span>
            <mat-progress-spinner
                *ngIf="this.duplicating"
                [diameter]="24"
                [mode]="'indeterminate'"
                matTooltip="Regel wird gelöscht..."></mat-progress-spinner>
        </button>

    </div>

</div>
